const originOfFunds = [
  {label: 'Salario', value: 'salary'},
  {label: 'Fondos Mutuos', value: 'mutualFunds'},
  {label: 'Acciones', value: 'shares'},
  {label: 'Depósito a Plazo', value: 'dap'},
  {label: 'Ahorro Previsional Voluntario', value: 'apv'},
  {label: 'Criptomonedas', value: 'crypto'},
  {label: 'Arriendo de Propiedades', value: 'rent'},
  {label: 'Otro', value: 'other'}
]

const formValidation = [
  {
    fieldName: 'fundsOrigin',
    fieldNick: 'Origen de fondos',
    isValid: val => {
      return val ? (val !== undefined && val.length > 0) : false
    }
  }
]

export {originOfFunds, formValidation}
